import { render, staticRenderFns } from "./Upcoming.vue?vue&type=template&id=56e5bb4c&scoped=true&"
import script from "./Upcoming.vue?vue&type=script&lang=js&"
export * from "./Upcoming.vue?vue&type=script&lang=js&"
import style0 from "./Upcoming.vue?vue&type=style&index=0&id=56e5bb4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e5bb4c",
  null
  
)

export default component.exports